import styles from './Link.module.scss';
import { Link as RRLink } from 'react-router-dom';

export default function Link (props) {
  return <RRLink {...props} className={styles.link} />
}
